// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ar-z","tooltipWrapper":"Br-z","icon":"Cr-z","tooltip":"Dr-z","content":"Er-z"};